import { forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import { StyledSectionLink, StyledSectionLinkButton } from './styled';

const SectionLink = forwardRef((props, ref) => {
  const { as, to, ...rest } = props;

  const location = useLocation();

  if (as === 'button') {
    return <StyledSectionLinkButton ref={ref} {...rest} />;
  } else {
    return (
      <StyledSectionLink
        ref={ref}
        to={to}
        {...rest}
        isActive={
          location.pathname.includes(to) && !location.state?.backgroundLocation
        }
      />
    );
  }
});

export default SectionLink;
